import { action } from "typesafe-actions";

import { message } from "antd";

import { PaginatedResponse, PaginationPayload } from "../common_types";

import { Alert, AlertsActionTypes } from "./types";

export const alertsFetchRequest = (payload: PaginationPayload) => action(AlertsActionTypes.LIST_FETCH_REQUEST, payload);

export const alertsFetchSuccess = (payload: PaginatedResponse<Alert>) =>
  action(AlertsActionTypes.LIST_FETCH_SUCCESS, payload);

export const alertsFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AlertsActionTypes.LIST_FETCH_ERROR);
};

export const unreadAlertsFetchRequest = () => action(AlertsActionTypes.UNREAD_LIST_FETCH_REQUEST);

export const unreadAlertsFetchSuccess = (payload: { items: Alert[] }) =>
  action(AlertsActionTypes.UNREAD_LIST_FETCH_SUCCESS, payload);

export const unreadAlertsFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AlertsActionTypes.UNREAD_LIST_FETCH_ERROR);
};

export const readAlertRequest = (payload: { id: number }) => action(AlertsActionTypes.READ_ALERT_REQUEST, payload);

export const readAlertSuccess = (payload: { id: number }) => action(AlertsActionTypes.READ_ALERT_SUCCESS, payload);

export const readAlertError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AlertsActionTypes.READ_ALERT_ERROR);
};
